function bytesToMB(bytes) {
    return bytes / (1024 * 1024);
}
export default bytesToMB;